<template>
        <div class="section__filters">
          <div class="cols">
              <div class="col-md-4">
                  <div class="form__element">
                      <div class="form__title">Buscar</div>
                      <div class="form__input">
                      <input type="text" />
                      </div>
                  </div>
              </div>
              <div class="col-md-4">
                  <div class="form__element">
                      <div class="form__title">A-Z</div>
                      <div class="form__input">
                      <select>
                          <option selected="selected" value="*">Todos</option>
                      </select>
                      </div>
                  </div>
              </div>
              <div class="col-md-4">
                  <div class="form__element">
                      <a class="btn" @click="btnNew()">Agregar Nuevo</a>
                  </div>
              </div>
          </div>
        </div>
</template>
<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import { mapGetters, mapActions } from "vuex";

export default {
    name: 'GetFilterAdministrators',
    mounted() {},
    computed: mapGetters(["adminsList"]),
    created() {
      this.fetchAdmins()
    },
    methods: {
        ...mapActions(["fetchAdmins"]),
        btnNew:async function(){
            await Swal.fire({
            title: 'Nuevo Administrador',
            html:
            '<div class="form-group">'+
                '<div class="row">'+
                    '<div class="form__element">'+
                        '<div class="form__title">Nombre</div>'+
                        '<div class="form__input">'+
                            '<input id="first_name"" type="text" class="form-control">'+
                        '</div>'+
                    '</div>'+
                    '<div class="form__element">'+
                        '<div class="form__title">Apellido</div>'+
                        '<div class="form__input">'+
                            '<input id="last_name"" type="text" class="form-control">'+
                        '</div>'+
                    '</div>'+
                    '<div class="form__element">'+
                        '<div class="form__title">Correo</div>'+
                        '<div class="form__input">'+
                            '<input id="email"" type="email" class="form-control">'+
                        '</div>'+
                    '</div>'+
                    '<div class="form__element">'+
                        '<div class="form__title">Contraseña</div>'+
                        '<div class="form__input">'+
                            '<input id="password"" type="password" class="form-control">'+
                        '</div>'+
                    '</div>'+
                '</div>'+
            '</div>', 
            focusConfirm: false,
            showCancelButton: true, 
            confirmButtonText: 'Crear',
            preConfirm: () => {
                if(document.getElementById('first_name').value == ""){
                    Swal.showValidationMessage(
                        `Error: "Completa el campo"`
                    )
                }else{
                    Swal.showValidationMessage()
                    var element = document.getElementById("swal2-validation-message");
                    element.classList.add("swal2-success-message-hide");
                    var body = {
                        'first_name'  : document.getElementById('first_name').value,
                        'last_name'  : document.getElementById('last_name').value,
                        'email'  : document.getElementById('email').value,
                        'password'  : document.getElementById('password').value,
                    }
                    var url = process.env.VUE_APP_URL_API+'/auth/admin/create';
                    var token = window.localStorage.getItem('token');
                    var params =  {
                        headers: {
                            Authorization: token,
                        },
                    }
                    //forma correcta de enviar url, body y params en axios
                    axios.post(url,body,params)
                        .then((response) => {
                            if (response.data.code==200) {
                                
                                Swal.showValidationMessage(
                                    `Success: ${response.data.message}`
                                )
                                element.classList.add("swal2-success-message");
                                this.fetchAdmins();
                            }else{
                                console.log(response.data.message) //mensaje de error}
                                Swal.showValidationMessage(
                                    `Success: ${response.data.message}`
                                )
                            }
                        })
                        .catch((error) => {
                            if (error.response.status === 401) {
                                console.log('error 401, no te encuentras autorizado.')
                                this.$router.push('/logout')
                            }
                            if (error.response.status === 404) {
                                console.log('error 404, Endpoint no encontrado.')
                                }
                            });
                        }

                },
            })
            
        },    
    },
    beforeUnmount() {

    }
}
</script>